<span class="ramme-tittel">{{ 'Brukertilgang'|translate }}</span>
<div class="tilgangsroller">
  @for (rolle of tilgjengeligeTilgangsroller; track rolle.rolleinfo.rolle) {
    <mat-checkbox [formControl]="rolle.kontroller">
      <div class="tittel">{{ rolle.rolleinfo.tittel(enumOversettelser) }}</div>
      <div class="subtittel">{{ rolle.rolleinfo.subtittel(enumOversettelser) }}</div>
    </mat-checkbox>
  }
</div>
